// App configuration. Real values only — no mock or seed data lives in this repo.
// The lead feed, scores, markets, and contractor intel all come from the backend
// at this URL (Woodcode2/solarlead-backend on Railway).
export const API_URL = "https://solarlead-backend-production.up.railway.app";
